import { useMutation, useQuery } from '@tanstack/react-query'
import { useApiClient } from '@chilipiper/api-client/src/context'
import { ReserveMeetingAttemptRequest } from '@chilipiper/api-client/src/user-availability'

const userAvailabilityQueryKeys = {
  meetingAttempt: (tenantId: string, meetingAttemptId: string) => [
    'meeting-attempt',
    tenantId,
    meetingAttemptId,
  ],
}
export const useMeetingAttempt = ({
  tenantId,
  meetingAttemptId,
}: {
  meetingAttemptId: string
  tenantId: string
}) => {
  const { userAvailabilityV2 } = useApiClient()
  return useQuery({
    queryKey: userAvailabilityQueryKeys.meetingAttempt(tenantId, meetingAttemptId),
    queryFn: () => userAvailabilityV2.getMeetingAttemptV2(tenantId, meetingAttemptId),
  })
}

export const useClaimMeetingAttemptReservation = ({
  tenantId,
  meetingAttemptId,
}: {
  meetingAttemptId: string
  tenantId: string
}) => {
  const { userAvailability } = useApiClient()
  return useMutation({
    mutationFn: (data: ReserveMeetingAttemptRequest) =>
      userAvailability.claimAMeetingAttemptReservation(tenantId, meetingAttemptId, data),
  })
}

export const useCancelMeetingAttemptReservation = ({
  tenantId,
  meetingAttemptId,
}: {
  meetingAttemptId: string
  tenantId: string
}) => {
  const { userAvailability } = useApiClient()
  return useMutation({
    mutationFn: ({ reservationId }: { reservationId: string }) =>
      userAvailability.cancelReservationOfMeetingAttempt(tenantId, meetingAttemptId, reservationId),
  })
}
